import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-container", {
    staticClass: "layout-cont"
  }, [_c("el-container", {
    class: [_vm.isSider ? "openside" : "hideside", _vm.isMobile ? "mobile" : ""]
  }, [_c("el-row", {
    class: [_vm.isShadowBg ? "shadowBg" : ""],
    nativeOn: {
      click: function click($event) {
        return _vm.changeShadow();
      }
    }
  }), _c("el-aside", {
    staticClass: "main-cont main-left"
  }, [_c("div", {
    staticClass: "tilte"
  }, [_c("img", {
    staticClass: "logoimg",
    attrs: {
      alt: "",
      src: require("@/assets/nav_logo.png")
    }
  }), _vm.isSider ? _c("h2", {
    staticClass: "tit-text"
  }, [_vm._v(_vm._s(_vm.titleName))]) : _vm._e()]), _c("Aside", {
    staticClass: "aside"
  })], 1), _c("el-main", {
    staticClass: "main-cont main-right"
  }, [_c("transition", {
    attrs: {
      duration: {
        enter: 800,
        leave: 100
      },
      mode: "out-in",
      name: "el-fade-in-linear"
    }
  }, [_c("div", {
    staticClass: "topfix",
    style: {
      width: "calc(100% - ".concat(_vm.isMobile ? "0px" : _vm.isCollapse ? "54px" : "220px", " - 15px)")
    }
  }, [_c("el-row", [_c("el-header", {
    staticClass: "header-cont"
  }, [_c("el-col", {
    attrs: {
      xs: 2,
      lg: 1,
      md: 1,
      sm: 1,
      xl: 1
    }
  }, [_c("div", {
    staticClass: "menu-total",
    on: {
      click: _vm.totalCollapse
    }
  }, [_vm.isCollapse ? _c("i", {
    staticClass: "el-icon-s-unfold"
  }) : _c("i", {
    staticClass: "el-icon-s-fold"
  })])]), _c("el-col", {
    attrs: {
      xs: 10,
      lg: 14,
      md: 14,
      sm: 9,
      xl: 14
    }
  }, [_c("el-breadcrumb", {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l(_vm.matched.slice(1, _vm.matched.length), function (item) {
    return _c("el-breadcrumb-item", {
      key: item.path
    }, [_vm._v(_vm._s(item.meta.title) + " ")]);
  }), 1)], 1), _c("el-col", {
    attrs: {
      xs: 12,
      lg: 9,
      md: 9,
      sm: 14,
      xl: 9
    }
  }, [_c("div", {
    staticClass: "fl-right right-box"
  }, [_c("Search"), _c("Screenfull", {
    staticClass: "screenfull",
    style: {
      cursor: "pointer"
    }
  }), _c("el-dropdown", [_c("span", {
    staticClass: "header-avatar"
  }, [_c("CustomPic"), _c("span", {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.nickName))]), _c("i", {
    staticClass: "el-icon-arrow-down"
  })], 1), _c("el-dropdown-menu", {
    staticClass: "dropdown-group",
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", {
    attrs: {
      icon: "el-icon-s-custom"
    },
    nativeOn: {
      click: function click($event) {
        return _vm.toPerson.apply(null, arguments);
      }
    }
  }, [_vm._v("个人信息 ")]), _c("el-dropdown-item", {
    attrs: {
      icon: "el-icon-table-lamp"
    },
    nativeOn: {
      click: function click($event) {
        return _vm.LoginOut.apply(null, arguments);
      }
    }
  }, [_vm._v("登 出 ")])], 1)], 1)], 1)])], 1)], 1), _c("HistoryComponent")], 1)]), !_vm.$route.meta.keepAlive && _vm.reloadFlag ? _c("transition", {
    attrs: {
      mode: "out-in",
      name: "el-fade-in-linear"
    }
  }, [_c("keep-alive", [_c("router-view", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingFlag,
      expression: "loadingFlag"
    }],
    key: _vm.key,
    staticClass: "admin-box",
    attrs: {
      "element-loading-text": "正在加载中"
    }
  })], 1)], 1) : _vm._e(), _vm.$route.meta.keepAlive && _vm.reloadFlag ? _c("transition", {
    attrs: {
      mode: "out-in",
      name: "el-fade-in-linear"
    }
  }, [_c("router-view", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingFlag,
      expression: "loadingFlag"
    }],
    staticClass: "admin-box",
    attrs: {
      "element-loading-text": "正在加载中"
    }
  })], 1) : _vm._e(), _c("BottomInfo")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };